module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Select', {
    ref: "selectApiContainer",
    attrs: {
      "placeholder": "Selecione",
      "options": _vm.list,
      "opt-id": "id",
      "opt-text": _vm.optText,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.changeSelect
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f34cb68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Input/SelectApi.vue
// module id = 888
// module chunks = 1